import styled from "styled-components";
export const IconBase = styled.div `
  display: inline-flex;
  align-self: flex-start;
  & > svg {
    & > path {
      fill: #003366;
    }
  }
`;
//# sourceMappingURL=coopIconsStyled.js.map